module.exports = __webpack_public_path__ + "img/icon_eyes.4e3f0579.svg";